<template>
  <label class="input-field">
    <span class="input-field-label"><slot /></span>
    <input
      v-if="editable"
      ref="dataField"
      type="password"
      class="input-field-field"
      v-model="dataValue"
      :placeholder="placeHolderText"
      @change="updated"
    >
    <span
      v-if="!editable"
      class="input-field-content"
    >● ● ● ● ● ● ● ● ● ● ● ● </span>
  </label>
</template>

<script>
export default {
	name: "PasswordField",
	props: {
		fieldType: {
			type: String,
			default: "text"
		},
		value: {
			type: [String, Number],
			default: null
		},
		updateWhenMounted: {
			type: Boolean,
			default: false
		},
		tip:{
			type: String,
			default:null
		},
		editable:{
			type: Boolean,
			default: true
		},
		placeHolderText:{
			type:String,
			default:""
		}
	},
	data() {
		return {
			dataValue: ''
		}
	},
	watch: {

	},
	mounted() {
		this.init();
	},
	methods: {
		init() {
			this.dataValue = this.value
		},
		updated(){
			this.$emit("input", this.dataValue);
		}
	}
}
</script>
<style lang="scss" scoped>
@use "../../scss/_variables.scss";

.input-field{
	margin-bottom: 8px;
	display: inline-block;
	text-align: left;
	width: 100%;
	&-label{
		display: inline-block;
		padding-top: 14px;
		font-size: 13px;
		font-family: variables.$font-primary;
	}
	&-field{
		display: inline-block;
		width: 70%;
		float: right;
		margin-top: 5px;
		color: variables.$color-text-primary;
		padding:10px;
		border: 2px solid variables.$color-field-border;
		border-radius: 5px;
		font-size: 14.5px;
		height: 3rem;

		&:focus{
			outline: none;
			border-bottom: 2px solid #479dea;
		}
	}
	&-content{
		display: inline-block;
		width: 70%;
		float: right;
		color: variables.$color-text-primary;
		font-size: 14px;
		padding-top: 10px;
		text-align: right;
	}
}
</style>
